module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAqYAAAAEAQMAAABm/m8QAAAAA1BMVEUQc+OGTQddAAAADElEQVQY02MYBTQBAAFYAAGJWdjWAAAAAElFTkSuQmCC"